<template lang="pug">
  .heading-container
    h2.primary-title(v-if="type >=1")
      slot(name="primary-title")
    h3.secondary-title(v-if="type >=1")
      slot(name="secondary-title")
    p.info-text(v-if="type >=2")
      slot(name="info-text")
</template>
<script>
export default {
  props: {
    type: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@design";

.heading-container {
  .primary-title {
    font-size: 1rem;
    line-height: 1.125rem;
    margin-top: 1.875rem;
    font-weight: bold;
    b {
      color: $muted-color;
    }
    text-align: left;
  }
  .secondary-title {
    text-align: left;
    margin-top: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;

    font-weight: normal;
    // text-transform: uppercase;
    color: $color-heading-text;
  }
  .info-text {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  @media (min-width: $vh-desktop) {
    margin-top: 2.5rem;
    .primary-title {
      font-size: 1.428rem;
      line-height: 1.714rem;
    }
    .secondary-title {
      margin-top: 0.5rem;
      font-size: 1rem;
    }
  }
}
</style>
